<template>
  <v-row>
    <v-col cols="12" sm="12">
      <TitleAndSearch
        :icon="'icon_agents'"
        :title="'Configuraciones de Eventos'"
        :showSearch="showSearch"
        :loading="loading"
        :searchTermInputReset="searchTermInputReset"
      />
      <v-row>
        <v-col cols="12">
          <AgentDataTable @setLoading="setLoading" @resetSearchInput="resetSearchInput" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import TitleAndSearch from '@/components/TitleAndSearch.vue'
import AgentDataTable from '@/components/agents/list/datatable/DataTable.vue'
export default {
  name: 'AgentsView',
  components: {
    TitleAndSearch,
    AgentDataTable
  },
  data() {
    return {
      showSearch: true,
      loading: false,
      searchTermInputReset: false
    }
  },
  methods: {
    showSearchInput() {
      const currentRoute = this.$router.currentRoute
      if (currentRoute.name !== 'AgentsList') this.showSearch = false
      else this.showSearch = true
    },
    setLoading(isLoading) {
      this.loading = isLoading
    },
    resetSearchInput(reset) {
      this.searchTermInputReset = reset
    }
  },
  created() {
    this.showSearchInput()
  },

  updated() {
    this.showSearchInput()
  }
}
</script>

<style></style>
